module.exports = __webpack_public_path__ + "static/media/visa-logo.bd98e975.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/ways-to-pay/visa-logo.png
// module id = 2233
// module chunks = 0